/** What the current build exposes (docs/PLAN.md). */

import type { CorrectionId } from './optics/profile';

export const FEATURES = {
  conditions: {
    aphakia: true,
    cataract: true,
    keratoconus: true,
    glaucoma: true,
    amd: true,
    dr: true,
    hr: true,
    rp: true,
    amblyopia: true,
  },
  /** Toric lenses are separate entries (D-011), offered only with astigmatism (D-019). */
  corrections: [
    'none', 'glasses', 'progressive', 'rgp', 'lasik', 'icl', 'icl_toric',
    'iol_mono', 'iol_mono_toric', 'iol_monoplus', 'iol_monoplus_toric',
    'iol_edof', 'iol_edof_toric', 'iol_tri', 'iol_tri_toric',
  ] as CorrectionId[],
  gaze: true,
  zoom: true,
  tags: true,
} as const;
